import { render } from "./index.vue?vue&type=template&id=bf309c3e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bf309c3e&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__